module.exports = {"530624101":"翠华镇","530624102":"玉碗镇","530624103":"吉利镇","530624104":"天星镇","530624105":"木杆镇","530624106":"悦乐镇","530624107":"寿山镇","530624108":"高桥镇","530624201":"上高桥回族彝族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530624.json
// module id = 2583
// module chunks = 0